import {Injectable} from '@angular/core';
import {TmsCollector, TmsCollectorConfig, WindowObject} from '@spartacus/tracking/tms/core';
import {CxEvent} from '@spartacus/core';
import {DataTrackingService} from './data-tracking.service';
import {DcpDataService} from './dcp-data.service';
import {DcpPageHitDataService} from './dcp-page-hit-data.service';
import {DcpProductDetailsPageHitDataService} from './dcp-product-details-page-hit-data.service';
import {isObservable} from 'rxjs';
import {AdobeTrackingData} from './models/adobe-tracking-data';
import {DcpSearchPageHitService} from './dcp-search-page-hit.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {DcpAddToCartDataService} from './dcp-add-to-cart-data.service';
import {DcpOrderPlacedEventDataService} from './dcp-order-placed-event-data.service';
import {FeatureTogglesService} from '@dcp/configurator';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DcpAdobeCollectorService implements TmsCollector {

  private featureIsEnabled: boolean = false;
  private dataServiceSet: Set<DcpDataService<AdobeTrackingData>> = new Set<DcpDataService<AdobeTrackingData>>();

  constructor(
    private featureToggleService: FeatureTogglesService,
    private dataTrackingService: DataTrackingService,
    private dcpPageHitData: DcpPageHitDataService,
    private dcpProductDetailsPageHitData: DcpProductDetailsPageHitDataService,
    private searchPageHitService: DcpSearchPageHitService,
    private addToCartData: DcpAddToCartDataService,
    private orderPlacedEventDataService: DcpOrderPlacedEventDataService,
  ) {
    this.featureToggleService.isEnabled(UNLEASH_TOGGLES.spartacusTagManagement)
      .pipe(untilDestroyed(this))
      .subscribe((enabled) => this.featureIsEnabled = enabled);
    this.dataServiceSet.add(this.dcpPageHitData);
    this.dataServiceSet.add(this.dcpProductDetailsPageHitData);
    this.dataServiceSet.add(this.searchPageHitService);
    this.dataServiceSet.add(this.addToCartData);
    this.dataServiceSet.add(this.orderPlacedEventDataService);
  }

  init(config: TmsCollectorConfig, window: WindowObject): void {
    window.dcpDataLayer = window.dcpDataLayer ?? [];
  }

  pushEvent<T extends CxEvent>(
    config: TmsCollectorConfig,
    window: WindowObject,
    event: T | any
  ): void {
    if (this.featureIsEnabled) {
      this.dataServiceSet.forEach((dataService) => {
        const data = dataService.getData(event);
        if (isObservable(data)) {
          data.pipe(untilDestroyed(this)).subscribe((observableData) => this.sendData(window, observableData));
        } else {
          this.sendData(window, data);
        }
      });
    }
  }

  protected sendData(window: WindowObject, data: any): void {
    if (data) {
      DcpAdobeCollectorService.updateDataLayer(window, data);
      this.dataTrackingService.trackData(data);
    }
  }

  protected static updateDataLayer(window: WindowObject, data: AdobeTrackingData): void {
    if (data) {
      window.dcpDataLayer.push(data);
    }
  }
}



